import {useReducedMotion} from 'framer-motion';
import {AppContext} from "../../context/AppContext";
import {motion} from 'framer-motion';
import Filter from './components/Filter/Filter';
import List from './components/List/List';
import Button from '../elements/Button/Button';
import invoicesLengthMessage from '../../utilities/invoicesLengthMessage';
import {invoicesVariants} from '../../utilities/framerVariants';
import styles from './Invoices.module.scss';
import clsx from "clsx";
import React, {useContext, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchInvoices} from "../../store/actions/invoicesActions";
import {fetchCustomer} from "../../store/actions/customerActions";
import {getProfile} from "../../store/actions/profileActions";
import {getUsers} from "../../store/actions/userActions";
import UserFilter from "./components/UserFilter/UserFilter";
import useFilter from "../../hooks/useFilter";
import Sort from "./components/Sort/Sort";
import DateFilter from "./components/DateFilter/DateFilter";
import InfoTooltip from "../elements/Info/Info";

const Invoices = () => {
    const dispatch = useDispatch();
    const profile = useSelector((state) => state.profile);
    const {
        windowWidth,
        setIsFormOpen,
        setIsInvoiceEdited,
        isAdmin
    } = useContext(AppContext);
    const {invoices} = useSelector((state) => state.invoices);
    const {filters} = useFilter();
    const isDesktop = windowWidth >= 768;
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? invoicesVariants.reduced
            : invoicesVariants[element];
    };

    const checkProfileData = () => {
        if (profile.profile) {
            if (!profile.profile.taxNumber ||
                !profile.profile.address ||
                !profile.profile.address_ukr ||
                !profile.profile.name_ukr ||
                !profile.profile.surname_ukr
            )
                return false;
        }
        return true;
    }

    const handleCreateInvoice = () => {
        setIsFormOpen(true);
        setIsInvoiceEdited(false);
    }

    useEffect(() => {
        dispatch(fetchCustomer());
        if (isAdmin) dispatch(getUsers());
    }, [isAdmin]);

    useEffect(() => {
        if (!profile.profile) {
            dispatch(getProfile());
        }
        console.log(profile.profile);
    }, [dispatch, profile.profile]);

    useEffect(() => {
        if (profile.profile) {
            dispatch(fetchInvoices());
        }
    }, [dispatch, profile]);

    return (
        <section className={styles.section}>
            <motion.div
                className={styles.header}
                variants={variant('header')}
                initial="hidden"
                animate="visible"
                exit="exit"
            >
                <div className={styles.textContainer}>
                    <h2 className={styles.heading}>Invoices</h2>
                    <p>
                        {invoicesLengthMessage(
                            invoices,
                            filters,
                            windowWidth
                        )}
                    </p>
                </div>
                {isAdmin && <Sort isDesktop={isDesktop}/>}
                {isAdmin && <DateFilter isDesktop={isDesktop}/>}
                {isAdmin && <UserFilter isDesktop={isDesktop}/>}
                <Filter isDesktop={isDesktop}/>
                {!isAdmin && (
                    <>
                        <Button className={clsx('primary', styles.invoiceButton)} type="button"
                                onClick={handleCreateInvoice} disabled={!checkProfileData()}>
                            New {isDesktop && 'Invoice'}
                        </Button>
                        <InfoTooltip
                            paragraphs={[
                                'If the New Invoice button is disabled,',
                                'please ensure that the profile form has been completed.'
                            ]}
                        />
                    </>
                )}
            </motion.div>
            <List/>
        </section>
    );
};

export default Invoices;
